export default __webpack_public_path__ + "static/media/heavycloud.7d1a859e.mp4";